<template>
  <el-dialog title="Thông báo" :visible.sync="localVisible" width="560px" :append-to-body="false">
    <div style="word-break: keep-all;">
      Hiện tại hệ thống không còn bài tập phù hợp để tiếp tục việc thanh tra.
      <div>Vui lòng quay lại thực hiện phân loại lỗi</div>
    </div>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-purple font-weight-bold mr-2" @click="$emit('go-back')">
        <i class="fas fa-arrow-right"></i> Quay lại
      </button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  name: 'NoHomeworkMoreDialog',
  props: {
    visible: { type: Boolean, default: false },
  },
  computed: {
    localVisible: {
      get() { return this.visible; },
      set(v) { this.$emit('update:visible', v); }
    }
  }
}
</script>

<style scoped>
</style>


